import styled from 'styled-components';
export const FontOption = styled.span.withConfig({
  displayName: "FontOption",
  componentId: "smdrcm-0"
})(({
  fontFamily,
  cssStyles
}) => {
  return Object.assign({
    fontFamily
  }, cssStyles);
});